import * as i0 from '@angular/core';
import { EventEmitter, forwardRef, Output, Input, ViewEncapsulation, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { Validators, NG_VALUE_ACCESSOR, ReactiveFormsModule, FormsModule } from '@angular/forms';
import * as i2 from '@ctrl/ngx-codemirror';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
import * as i3 from '@engineering11/ui-lib/e11-input-label';
import { E11InputLabelModule } from '@engineering11/ui-lib/e11-input-label';
import { CommonModule } from '@angular/common';
import 'codemirror/mode/htmlembedded/htmlembedded';
import 'codemirror/mode/markdown/markdown';

class E11InputCodeComponent {
    constructor() {
        this.hasError = false;
        this.required = false;
        this.disabled = false;
        this.labelTextOptional = '(Optional)';
        /* called when the text cursor is moved */
        this.cursorActivity = new EventEmitter();
        /* called when the editor is focused or loses focus */
        this.focusChange = new EventEmitter();
        /* called when the editor is scrolled */
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.scroll = new EventEmitter();
        /* called when file(s) are dropped */
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.drop = new EventEmitter();
        /* called when codeMirror instance is initiated on the component */
        this.codeMirrorLoaded = new EventEmitter();
        this.change = new EventEmitter();
        this.onChange = () => { };
        this.onTouch = () => { };
    }
    writeValue($event) { }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    ngOnInit() {
        this.required = this.formControl.hasValidator(Validators.required);
    }
    modelValueChange(value) {
        this.onChange(value);
        this.change.emit(value);
    }
    get formControl() {
        return this.parentForm.controls[this.formControlName];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11InputCodeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11InputCodeComponent, selector: "e11-input-code", inputs: { value: "value", parentForm: "parentForm", formControlName: "formControlName", label: "label", containerClass: "containerClass", hasError: "hasError", required: "required", disabled: "disabled", tooltipConfig: "tooltipConfig", labelTextOptional: "labelTextOptional" }, outputs: { cursorActivity: "cursorActivity", focusChange: "focusChange", scroll: "scroll", drop: "drop", codeMirrorLoaded: "codeMirrorLoaded", change: "change" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => E11InputCodeComponent),
                multi: true,
            },
        ], ngImport: i0, template: "<div class=\"e11-input-code\" [formGroup]=\"parentForm\">\n  <e11-input-label\n    [for]=\"formControlName\"\n    [label]=\"label\"\n    [required]=\"required\"\n    [disabled]=\"disabled\"\n    [hasError]=\"hasError\"\n    [tooltipConfig]=\"tooltipConfig\"\n    [labelTextOptional]=\"labelTextOptional\"\n  ></e11-input-label>\n\n  <div class=\"e11-border e11-border-gray-300 {{ containerClass }}\">\n    <ngx-codemirror\n      [name]=\"formControlName\"\n      [formControlName]=\"formControlName\"\n      [options]=\"{\n        lineNumbers: true,\n        mode: 'htmlmixed',\n      }\"\n      (cursorActivity)=\"cursorActivity.emit($event)\"\n      (focusChange)=\"focusChange.emit($event)\"\n      (scroll)=\"scroll.emit($event)\"\n      (drop)=\"drop.emit($event)\"\n      (codeMirrorLoaded)=\"codeMirrorLoaded.emit($event)\"\n      (ngModelChange)=\"modelValueChange($event)\"\n    ></ngx-codemirror>\n  </div>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i2.CodemirrorComponent, selector: "ngx-codemirror", inputs: ["className", "name", "autoFocus", "options", "preserveScrollPosition"], outputs: ["cursorActivity", "focusChange", "scroll", "drop", "codeMirrorLoaded"] }, { kind: "component", type: i3.E11InputLabelComponent, selector: "e11-input-label", inputs: ["label", "id", "for", "size", "labelClassOverrides", "required", "hasError", "disabled", "darkMode", "requiredMode", "labelTextOptional", "tooltipConfig"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11InputCodeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-input-code', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => E11InputCodeComponent),
                            multi: true,
                        },
                    ], encapsulation: ViewEncapsulation.None, template: "<div class=\"e11-input-code\" [formGroup]=\"parentForm\">\n  <e11-input-label\n    [for]=\"formControlName\"\n    [label]=\"label\"\n    [required]=\"required\"\n    [disabled]=\"disabled\"\n    [hasError]=\"hasError\"\n    [tooltipConfig]=\"tooltipConfig\"\n    [labelTextOptional]=\"labelTextOptional\"\n  ></e11-input-label>\n\n  <div class=\"e11-border e11-border-gray-300 {{ containerClass }}\">\n    <ngx-codemirror\n      [name]=\"formControlName\"\n      [formControlName]=\"formControlName\"\n      [options]=\"{\n        lineNumbers: true,\n        mode: 'htmlmixed',\n      }\"\n      (cursorActivity)=\"cursorActivity.emit($event)\"\n      (focusChange)=\"focusChange.emit($event)\"\n      (scroll)=\"scroll.emit($event)\"\n      (drop)=\"drop.emit($event)\"\n      (codeMirrorLoaded)=\"codeMirrorLoaded.emit($event)\"\n      (ngModelChange)=\"modelValueChange($event)\"\n    ></ngx-codemirror>\n  </div>\n</div>\n" }]
        }], propDecorators: { value: [{
                type: Input
            }], parentForm: [{
                type: Input
            }], formControlName: [{
                type: Input
            }], label: [{
                type: Input
            }], containerClass: [{
                type: Input
            }], hasError: [{
                type: Input
            }], required: [{
                type: Input
            }], disabled: [{
                type: Input
            }], tooltipConfig: [{
                type: Input
            }], labelTextOptional: [{
                type: Input
            }], cursorActivity: [{
                type: Output
            }], focusChange: [{
                type: Output
            }], scroll: [{
                type: Output
            }], drop: [{
                type: Output
            }], codeMirrorLoaded: [{
                type: Output
            }], change: [{
                type: Output,
                args: ['change']
            }] } });

class E11InputCodeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11InputCodeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11InputCodeModule, declarations: [E11InputCodeComponent], imports: [CommonModule, ReactiveFormsModule, FormsModule, CodemirrorModule, E11InputLabelModule], exports: [E11InputCodeComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11InputCodeModule, imports: [CommonModule, ReactiveFormsModule, FormsModule, CodemirrorModule, E11InputLabelModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11InputCodeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [E11InputCodeComponent],
                    imports: [CommonModule, ReactiveFormsModule, FormsModule, CodemirrorModule, E11InputLabelModule],
                    exports: [E11InputCodeComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11InputCodeComponent, E11InputCodeModule };
